import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const Section = styled.section`
  background-color: ${themeGet('colors.primary')};
  position: relative;
  min-height: 50rem;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-content: center;
  // align-items: center;
  `;

export const ContentWrapper = styled.div`

display: flex;
align-items: center;
bottom: center;
padding: 60px 40px;
text-align: center;

`;


export const TextContent = styled.div`
  z-index: 1;
  
    h2 {
    color: ${themeGet('colors.white')};
    max-width:100%;
    font-weight: 700;
    font-size: clamp(28px, 5vw, 62px);
    line-height: 1.2;
    white-space: pre-line;
    text-align: center;
    
  }

`;

export const ContactInfo = styled.div`
background-color: ${themeGet('colors.black')};
border-radius: 25px;
overflow: hidden;
padding: 40px 60px;
margin: 0 auto;
display: flex;

justify-content: space-between;
align-items: center;
width: 100%;
max-width: 800px;
background: rgba(0, 0, 0, 0.46);
bottom: 7+rem;
left: 50%;
transform: translateX(-50% );
position: absolute;
z-index: 2; 

@media only screen and  (max-width: 768px) {
    flex-direction: column;
    width: 300px;
    bottom: 2rem;
    padding: 40px 60px;
    text-align: center;
    }
@media only screen and  (max-width: 480px) {
    width: 80%;
    }
`;
  
export const ContactIcon = styled.div`
  color: #fff;
  font-size: 24px;
`;

export const ContactItem = styled.div`
  display: flex;
  align-items: center;
  color: #fff;
  gap: 15px;
  text-align: left;

  h4 {
    font-size: 18px;
    margin-bottom: 5px;
  }

  p {
    font-size: 14px;
    margin: 0;
  }

  a {
    color: #fff;
    text-decoration: none;
  }
   @media only screen and (max-width: 768px){
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: space-between;
    align-items: center; 
    margin-bottom: 25px;
  }

`;


export const Illustration = styled.figure`
  z-index: 0;
  position: relative;
  
  @media only screen and (max-width: 768px) {
    display: none;
    }
    img {
      max-width: 100%;
      margin-left: auto;
      @media only screen and (max-width: 1024px) {
      max-width: 500px;
      margin-left: 50px;
      }
  }
`;